import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'Utils/store'
import { selectDropdownSlice } from 'Slices/selectDropdownSlice'
import AddressVerifiedConfig from 'Configs/fields/address_verified.json'

export const AddressVerifiedSlice = selectDropdownSlice(
  AddressVerifiedConfig.column,
  AddressVerifiedConfig.values,
  'setOnDemandAddressVerified',
  AddressVerifiedConfig.meta
)

export const selectAddressVerified = createSelector(
  ({ onDemandFilter: { verification } }: RootState) =>
    verification['addressVerified'].selectedValue,
  (
    selectedValue: string
  ): { selectedValue: string; values: string[]; label } => {
    return { selectedValue, values: AddressVerifiedConfig.values, label: AddressVerifiedConfig.meta.label }
  }
)

export const { setOnDemandAddressVerified } = AddressVerifiedSlice.actions

export default AddressVerifiedSlice.reducer
